import { CreateJobImageCommand } from "@/models/app.model";
import axios from "axios";
import { BaseService } from "./base.service";

class ImageService extends BaseService {

    constructor() {
        super();
        console.log("created a instance of ImageService");
    }

    // --------------
    // ** GET **
    // --------------

    async getImageThumb(id:number){
        return axios.get(`${this.api}image/GetImageThumb?id=${id}`).then(req => { return req.data });
    }

    async getImageFile(id:number):Promise<Blob>{
        return axios.get(`${this.api}image/GetImageFile?id=${id}`,{ responseType: 'blob' }).then(req => { return req.data });
    }

    async getImage(id:number){
        return axios.get(`${this.api}image/Get?id=${id}`).then(req => { return req.data });
    }


    // --------------
    // ** CREATE **
    // --------------

    async createImage(formData: FormData) {
        return axios.post(`${this.api}Image/Create`, 
            formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(req => { return req.data });
    }

    async createJobImage(createJobImageCommand:CreateJobImageCommand){
        let result = await axios.post(`${this.api}job/CreateJobImage`, createJobImageCommand);
        return result;
        // return this.execute('post', `category/`, category);
    }

    async delete(id: number){
        let result = await axios.delete(`${this.api}image/Delete?id=${id}`);
        return result;
        // return this.execute('delete', `job/${id}`);
    }

    // --------------
    // ** UPDATE **
    // --------------


}

export const imageService = new ImageService();